import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import validator from 'validator';
import { updateStakeHolder } from 'src/services/projectService';
import { AppActions } from 'src/store/AppReducer';
import {
  Button,
  Grid,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import SearchIcon from '@mui/icons-material/Search';
import { useAppSelector } from 'src/hooks/hooks';
import MuiPhoneNumber from 'material-ui-phone-number';

export interface StakeholderInformation {
  name: string;
  designation: string;
  email: string;
  contact: string;
  customerId: string;
  segmentId: string;
}

const EditStakeHolder = ({ 
  toggle, 
  open, 
  getData, 
  data, 
  segments,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage  
}) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const { register, handleSubmit, reset } = useForm<StakeholderInformation>();

  const [nameError, setNameError] = useState('');
  const [designationError, setDesignationError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [contactError, setContactError] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const toggleConfirmation = () => {
    if (openConfirmation) {
      setOpenConfirmation(false);
    }
    if (
      stakeholderObj.name !== '' &&
      stakeholderObj.name.length < 31 &&
      stakeholderObj.name.trim().length > 0 &&
      stakeholderObj.designation !== '' &&
      stakeholderObj.designation.length < 31 &&
      stakeholderObj.designation.trim().length > 0 &&
      stakeholderObj.email !== '' &&
      stakeholderObj.email.trim().length > 0 &&
      stakeholderObj.contact !== '' &&
      stakeholderObj.contact.length > 11 &&
      validator.isEmail(stakeholderObj.email) &&
      customer &&
      segment
    ) {
      setNameError('');
      setDesignationError('');
      setEmailError('');
      setContactError('');
      setOpenConfirmation(!openConfirmation);
    } else if (stakeholderObj.name === '') {
      setNameError('Stakeholder name is required.');
    } else if (stakeholderObj.name.trim().length < 1) {
      setNameError('Stakeholder name cannot be only spaces');
    } else if (stakeholderObj.designation === '') {
      setDesignationError('Designation is required.');
    } else if (stakeholderObj.designation.trim().length < 1) {
      setDesignationError('Designation cannot be only spaces');
    } else if (stakeholderObj.email === '') {
      setEmailError('Email is required.');
    } else if (stakeholderObj.email.trim().length < 1) {
      setEmailError('Email cannot be only spaces');
    } else if (stakeholderObj.contact === '') {
      setContactError('Contact number is required.');
    } else if (stakeholderObj.contact.trim().length < 1) {
      setContactError('Contact cannot be only spaces');
    }else if (stakeholderObj.contact.trim().length < 12) {
      setContactError('Contact Number must not be less than 10 numbers.');
    } else if (!validator.isEmail(stakeholderObj.email)) {
      setEmailError('Invalid email address.');
    } else if (!segment) {
      setSegmentError('Segment is required.');
    } else if (!customer) {
      setCustomerError('Client is required.');
    }
  };

  const [stakeholderObj, setStakeholderObj] = useState<any>({
    name: data.name,
    id: data.id,
    designation: data.designation,
    email: data.email,
    contact: data.contactNumber,
    segmentId: data.segmentId,
    customerId: data.customerId
  });

  useEffect(() => {
    setStakeholderObj({
      name: data.name,
      id: data.id,
      designation: data.designation,
      email: data.email,
      contact: data.contactNumber,
      segmentId: data.segmentId,
      customerId: data.customerId
    });
  }, [data]);

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = () => {
    if (
      stakeholderObj.name !== '' &&
      stakeholderObj.name.length < 31 &&
      stakeholderObj.name.trim().length > 0 &&
      stakeholderObj.designation !== '' &&
      stakeholderObj.designation.length < 31 &&
      stakeholderObj.designation.trim().length > 0 &&
      stakeholderObj.email !== '' &&
      stakeholderObj.email.trim().length > 0 &&
      stakeholderObj.contact !== '' &&
      stakeholderObj.contact.length > 11 &&
      validator.isEmail(stakeholderObj.email) &&
      customer &&
      segment
    ) {
      dispatch(AppActions.showLoader());

      setNameError('');
      setDesignationError('');
      setEmailError('');
      setContactError('');

      const body = {
        name: data.name === stakeholderObj.name ? null : stakeholderObj.name,
        designation:
          data.designation === stakeholderObj.designation
            ? null
            : stakeholderObj.designation,
        email:
          data.email === stakeholderObj.email ? null : stakeholderObj.email,
        contactNumber:
          data.contact === stakeholderObj.contact
            ? null
            : stakeholderObj.contact,
        segmentId: data.segmentId,
        customerId: data.customerId,
        newCustomerId: data.customerId === customer ? null : customer,
        newSegmentId:
          data.customerId === customer && data.segmentId === segment
            ? null
            : segment,
        id: stakeholderObj.id
      };

      updateStakeHolder(body)
        .then(() => {
          reset();
          setSnackBarMessage('You have updated the stakeholder successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          toggle();
          toggleConfirmation();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          setSnackBarMessage( error?.request?.response ? error?.request?.response : 'Unable create a stakeholder');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
          toggle();
          toggleConfirmation();
        });
    } else if (stakeholderObj.name === '') {
      setNameError('Stakeholder name is required.');
    } else if (stakeholderObj.name.trim().length < 1) {
      setNameError('Stakeholder name cannot be only spaces');
    } else if (stakeholderObj.designation === '') {
      setDesignationError('Designation is required.');
    } else if (stakeholderObj.designation.trim().length < 1) {
      setDesignationError('Designation cannot be only spaces');
    } else if (stakeholderObj.email === '') {
      setEmailError('Email is required.');
    } else if (stakeholderObj.email.trim().length < 1) {
      setEmailError('Email cannot be only spaces');
    } else if (stakeholderObj.contact === '') {
      setContactError('Contact number is required.');
    } else if (stakeholderObj.contact.trim().length < 1) {
      setContactError('Contact cannot be only spaces');
    } else if (!validator.isEmail(stakeholderObj.email)) {
      setEmailError('Invalid email address.');
    } else if (!segment) {
      setSegmentError('Segment is required.');
    } else if (!customer) {
      setCustomerError('Client is required.');
    }
  };

  const [segmentError, setSegmentError] = useState('');
  const [customerError, setCustomerError] = useState('');
  const [customers, setCustomers] = useState([]);
  const [segment, setSegment] = useState('');
  const [customer, setCustomer] = useState('');

  useEffect(() => {
    setCustomers(segments.filter((seg) => seg.id === segment)[0]?.customers);
  }, [segment, segments, data]);

  useEffect(() => {
    const singleSegment = segments.filter(
      (seg) => data?.segmentId === seg.id
    )[0];
    setSegment(singleSegment.id);
  }, [data, segments]);

  useEffect(() => {
    const singleSegment = segments.filter((seg) => segment === seg.id)[0];
    setCustomers(singleSegment?.customers);
  }, [segment, segments]);

  useEffect(() => {
    setCustomer(customers?.filter((fil) => fil.id === data.customerId)[0]?.id);
  }, [customers, data]);

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setSelectedOption(data?.segmentId);
  }, [data]);

  const displayedOptions = useMemo(
    () =>
      segments.length > 0 &&
      segments?.filter((option) => containsText(option.name, searchText)),
    [searchText, segments]
  );

  const displayedCustomers = useMemo(
    () =>
    segment && customers?.length > 0 &&
    customers?.filter((option) => {      
      return containsText(option.name, searchText)
    }
    ),
    [searchText, customers]
  );

  const onClose = () => {
    setNameError('');
    setDesignationError('');
    setEmailError('');
    setContactError('');
    setCustomerError('');

    setStakeholderObj({
      name: data.name,
      id: data.id,
      designation: data.designation,
      email: data.email,
      contact: data.contactNumber,
      segmentId: data.segmentId,
      customerId: data.customerId
    });
    setSelectedOption(data?.segmentId);
    const singleSegment = segments.filter(
      (seg) => data?.segmentId === seg.id
    )[0];
    setCustomers(singleSegment?.customers);
    setCustomer(customers?.filter((fil) => fil.id === data.customerId)[0]?.id);
    toggle();
  };

  useEffect(() => {
    if(customer) {
      setCustomerError('');
    }
  }, [customer]);

  return (
    <Fragment>
      {' '}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 2 }}>
          <Typography style={{ fontSize: '15px' }} variant="h3">
            Edit Stakeholder
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Stakeholder Name<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="edit-StakeholderName"
              inputProps={{ maxLength: 30 }}
              size="small"
              {...register('name', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.name}
              placeholder="Enter Stakeholder Name"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setNameError(
                    'Stakeholder name must not exceed 30 characters'
                  );
                } else {
                  setNameError('');
                }
                setStakeholderObj((prev) => ({
                  ...prev,
                  name: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {nameError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Designation<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="edit-stakeholderDesignation"
              inputProps={{ maxLength: 30 }}
              size="small"
              {...register('designation', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.designation}
              placeholder="Enter Designation"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setDesignationError(
                    'Designation name must not exceed 30 characters'
                  );
                } else {
                  setDesignationError('');
                }
                setStakeholderObj((prev) => ({
                  ...prev,
                  designation: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {designationError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Email<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="edit-stakeholderEmail"
              size="small"
              {...register('email', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.email}
              placeholder="Enter Email"
              variant="outlined"
              autoComplete="new-password"
              onChange={(e) => {
                setStakeholderObj((prev) => ({
                  ...prev,
                  email: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {emailError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Contact Number<span style={{ color: 'red' }}>*</span>
            </Typography>
            <MuiPhoneNumber
            id="edit-stakeholderContactNumber"
            defaultCountry={'lk'}
            size="small"
            {...register('contact', {})}
            InputProps={{
              style: { fontSize: '12px', height: '2.25rem' }
            }}
            style={TextFieldStyle}
            fullWidth
            type="text"
            placeholder="Enter Contact Number"
            variant="outlined"
            value={stakeholderObj.contact}
            onChange={(e) => {
              setStakeholderObj((prev) => ({
                ...prev,
                contact: e
              }));
              if (e.length > 11) {
                setContactError('');
              }
            }}
          />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {contactError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Segment<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              id="edit-stakeholderSegment"
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              {...register('segmentId', {})}
              style={{
                height: '2.25rem',
                width: '94%',
                marginLeft: 15,
                marginTop: 5,
                paddingRight: 15,
                fontSize: '13px'
              }}
              displayEmpty
              defaultValue=""
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                setCustomers([]);
                setSegment(e.target.value);
              }}
              onClose={() => setSearchText('')}
            >
              <ListSubheader>
                <TextField
                  id="edit-stakeholderSegmentSearch"
                  size="small"
                  autoFocus
                  placeholder="Type to search..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== 'Escape') {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                Select Segment
              </MenuItem>
              {displayedOptions.length > 0 &&
                displayedOptions?.map((option, i) => (
                  <MenuItem key={i} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {segmentError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Client <span style={{ color: 'red' }}>*</span>
            </Typography>
            {customers?.length > 0 ? (
              <Select
                id="edit-stakeholderCustomer"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                className="select-text"
                size="small"
                fullWidth
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('customerId', {})}
                defaultValue={''}
                value={customer}
                onChange={(e) => {
                  if(e.target.value) {
                    setCustomer(e.target.value);
                    setCustomerError('');
                  }
                }}
              >
                {customers?.map((customer) => {
                  return (
                    <MenuItem value={customer.id}>{customer.name}</MenuItem>
                  );
                })}
              </Select>
            ) : (
              <Select
                id="edit-stakeholderCustomerName"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                className="select-text"
                size="small"
                fullWidth
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('customerId', {})}
                defaultValue={''}
                value={customer}
                onChange={(e) => {
                  setCustomer(e.target.value);
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="edit-stakeholderCustomerNameSearch"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation();
                      }
                    }}
                  ></TextField>
                </ListSubheader>
                {displayedCustomers?.length > 0 &&
                  displayedCustomers?.map((option, i) => (
                    <MenuItem key={i} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </Select>
            )}
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {customerError}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
            xs={12}
          >
            <Button
              id="edit-onClose"
              sx={{
                width: '10%',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px'
              }}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            <Button
              id="edit-onSubmit"
              disabled={stakeholderObj?.name === '' || isLoading}
              onClick={() => toggleConfirmation()}
              className={isLoading ? 'loading' : ''}
              sx={{
                ml: 2,
                width: '10%',
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              variant="contained"
              type="button"
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure want to update this stakeholder?`}
        onConfirm={() => onSubmit()}
        noToggle={toggleConfirmation}
      />
    </Fragment>
  );
};

export default EditStakeHolder;
